import { Component } from '@angular/core';
import { membersuiteDiscountProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Discount Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitediscountproduct-form',
    templateUrl: './membersuitediscountproduct.form.component.html'
})
export class membersuiteDiscountProductFormComponent extends BaseFormComponent {
    public record!: membersuiteDiscountProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

